import { mergeClasses } from '@fluentui/react-components';
import { useAccountAmountStyles } from '../../../hooks/useAccountAmountStyles';

export const AdjustmentTypeSpacerCell = () => {
    const styles = useAccountAmountStyles();
    return <div role='gridcell' className={mergeClasses(styles.adjustmentTypeColumn, styles.fontSize)}></div>;
};
